import { FieldInputProps } from 'react-final-form'

/**
 * @description if is an object return input.value.value or input.value
 */
export const getValue = (
  input: FieldInputProps<string, HTMLElement>
): {
  active: boolean
  duration: number | boolean
  guarantor: boolean
} => {
  if (typeof input.value === 'object') {
    const object = input.value as {
      active: boolean
      duration: number
      guarantor: boolean
    }
    return object
  }
  return {
    active: false,
    duration: false,
    guarantor: false,
  }
}
